import classNames from 'classnames';
import style from './Skeleton.module.css';

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: number | string;
  className?: string;
}

export const Skeleton = ({ width, height, borderRadius, className }: SkeletonProps) => {
  return (
    <span
      className={classNames('block !bg-neutral-200', style.skeleton, className)}
      style={{
        height: height || 14,
        width: width || '100%',
        borderRadius: borderRadius || 10,
      }}
    />
  );
};
